import React, { createContext, useContext, useEffect, useState } from 'react';
import { CONSTANTS } from '../utils/constants';

interface ThemeColors {
  primary: string;
  secondary: string;
}

interface ThemeContextType {
  colors: ThemeColors;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  updateColors: (newColors: ThemeColors) => void;
}

const defaultTheme: ThemeColors = {
  primary: CONSTANTS.DEFAULT_PRIMARY_COLOR,
  secondary: CONSTANTS.DEFAULT_SECONDARY_COLOR,
};

const ThemeContext = createContext<ThemeContextType>({
  colors: defaultTheme,
  isDarkMode: false,
  toggleDarkMode: () => {},
  updateColors: () => {},
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [colors, setColors] = useState<ThemeColors>(defaultTheme);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Initialize dark mode from localStorage
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setIsDarkMode(savedDarkMode);
    document.documentElement.setAttribute('data-theme', savedDarkMode ? 'dark' : 'light');
  }, []);

  // Toggle dark mode (preserves custom colors)
  const toggleDarkMode = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    localStorage.setItem('darkMode', String(newDarkMode));
    document.documentElement.setAttribute('data-theme', newDarkMode ? 'dark' : 'light');
  };

  const updateColors = (newColors: ThemeColors) => {
    setColors(newColors);
    console.log(newColors, '--------newcolors');
    document.documentElement.style.setProperty('--primary-color', newColors.primary);
    document.documentElement.style.setProperty('--secondary-color', newColors.secondary);
  };

  return (
    <ThemeContext.Provider value={{ colors, isDarkMode, toggleDarkMode, updateColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
